<template>
  <div class="real">
    <!--    <CommonTitle titleText="个人信息"></CommonTitle>
        <el-form :model="rulesForm" ref="formName" label-width="100px" label-position="left" :rules="rules">
          <el-form-item label="账号:" >
            <el-input v-model="rulesForm.loginName" placeholder="账号"></el-input>
          </el-form-item>

        </el-form>

        <div class="flex flex_align-items flex_justify-center button">
          <el-button @click="handleSaverUser('formName', 'rulesForm')"  style="width: 30%" type="primary" :loading="saverLoading">修改</el-button>
        </div>-->

    <CommonTitle titleText="身份信息"></CommonTitle>
    <el-form :model="form" ref="form" label-width="100px" label-position="left" :rules="rules">
      <el-form-item label="真实姓名:" prop="name">
        <el-input :disabled="disabledForm" v-model="form.name" placeholder="真实姓名"></el-input>
      </el-form-item>

      <el-form-item label="身份证号码:" prop="idCard">
        <el-input :disabled="disabledForm" v-model="form.idCard" placeholder="身份证号码"></el-input>
      </el-form-item>
    </el-form>

    <div class="careful">
      <h4>认证须知</h4>
      <p>1、实名认证通过后，将无法修改和删除，请谨慎填写；</p>
      <p>2、如存在恶意乱填写姓名，身份证号码，对您得学习记录会造成影响。</p>
    </div>

    <div class="flex flex_align-items flex_justify-center button" v-if="!disabledForm">
      <el-button @click="handleSaverUser('form', 'form')" style="width: 30%" type="primary" :loading="saverLoading">提交
      </el-button>
    </div>

    <div class="flex flex_align-items flex_justify-center button" v-if="disabledForm">
      <el-button  disabled style="width: 30%" type="success" :loading="saverLoading">已认证
      </el-button>
    </div>


  </div>
</template>

<script>
export default {
  name: "userRealName",
  data() {
    let checkIdCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身份证号码不能为空'));
      }
      setTimeout(() => {
        if (value.length < 18) {
          callback(new Error('请输入正确的身份证号码'));
        } else {
          callback();
        }
      }, 1000);
    };

    return {
      form: {
        name: '',
        idCard: ''
      },
      disabledForm: false,
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: ['blur', 'change']},
        ],
        idCard: [
          {required: true, validator: checkIdCard, trigger: ['blur']},
        ],
      },
      rulesForm: {
        loginName: ''
      },
      saverLoading: false,
    }
  },
  created() {
    this.$get(this.$API.MEMBER_INFO, {}).then(res => {
      if (res.code === 200) {
        this.userInfo = res.data
        for (let i in this.form) {
          this.form[i] = this.userInfo[i]
        }
        this.rulesForm.loginName = this.userInfo['loginName']

        if (this.userInfo.idCard && this.userInfo.name) {
          this.disabledForm = true
        }
      }
    })
  },
  methods: {
    handleSaverUser(formName, sverForm) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saverLoading = true
          this.$post(this.$API.MEMBER_SAVEMEMBER, {
            ...this[sverForm]
          }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '认证成功',
                type: 'success'
              });
              this.disabledForm = true

              this.$confirm('恭喜您，认证成功，是否前往我的课程进行学习?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).then(() => {
                setTimeout(() => {
                  this.$router.push('/home')
                }, 1000)
              }).catch(() => {});

            } else {
              this.$message.error(res.msg)
            }
            setTimeout(() => {
              this.saverLoading = false
            }, 1000)
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.careful {
  margin: 20px 0;
  color: #71777d;
  h4 {
    margin-bottom: 10px;
  }

  p {
    line-height: 40px;
  }
}


</style>
